<template>
  <div class="subscription-flow" v-if="!asyncLoading">
    <back-navigation-header v-if="eligibleForAnnualSubscriptionTest" :show-back="true" :on-back="onBack" />
    <!--We use v-show and not v-if because the credit-card component cannot be re-rendered-->
    <!--The fields in it are mounted by payme making rerendering heavy and destroying previous context-->
    <subscription-type v-if="flowStep === SUBSCRIPTION_FLOW_STEPS.subscriptionType" />

    <template v-else-if="flowStep === SUBSCRIPTION_FLOW_STEPS.creditCard">
      <credit-card
        v-show="flowStep === SUBSCRIPTION_FLOW_STEPS.creditCard"
        :first-billing-date="firstBillingDateByProposal"
        :money-back-guarantee="hasMoneyBackOffer"/>
    </template>

    <done v-else :first-billing-date="firstBillingDateByProposal"/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import * as moment from 'moment';
import BackNavigationHeader from '@/base-components/app-header/BackNavigationHeader';
import router from '@/router';
import MoneyBackPromotions from '@/mixins/MoneyBackPromotion';
import { SUBSCRIPTION_TYPES } from '@/constants/subscription-state';
import SubscriptionType from './pages/SubscriptionType.vue';
import CreditCard from './pages/CreditCard.vue';
import Done from './pages/Done.vue';
import Segment from '../../../../Segment';

export default {
  name: 'SubscriptionFlow',
  components: {
    BackNavigationHeader,
    SubscriptionType,
    CreditCard,
    Done,
  },
  data() {
    return {
      asyncLoading: true,
    };
  },
  mixins: [MoneyBackPromotions],
  async created() {
    Segment.trackUserGot('SubscriptionEntered', { moneyBack: this.hasMoneyBackOffer });
    await this.fetchFirstBillingDate();
    await this.fetchPricing();
    await this.fetchIsEligibleForAnnualSubscription();
    if (this.eligibleForAnnualSubscriptionTest) {
      Segment.trackUserGot('EligibleToAnnualSubscription');
    }

    const step = this.eligibleForAnnualSubscriptionTest ? this.SUBSCRIPTION_FLOW_STEPS.subscriptionType : this.SUBSCRIPTION_FLOW_STEPS.creditCard;
    const type = this.eligibleForAnnualSubscriptionTest ? SUBSCRIPTION_TYPES.YEARLY : SUBSCRIPTION_TYPES.MONTHLY;
    this.setStep(step);
    this.setType(type);
    this.asyncLoading = false;
  },
  computed: {
    ...mapGetters('subscription', ['SUBSCRIPTION_FLOW_STEPS']),
    ...mapState('subscription', ['firstBillingDate', 'flowStep', 'eligibleForAnnualSubscriptionTest']),
    ...mapState('benefits', ['benefitId']),
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
    ...mapGetters('featureFlags', ['moneyBackGuaranteeIsOn']),
    firstBillingDateByProposal() {
      return this.hasMoneyBackOffer ? moment().add(1, 'day').set('hour', 10).toString() : this.firstBillingDate;
    },
  },
  methods: {
    ...mapActions('subscription', ['fetchFirstBillingDate', 'fetchPricing', 'fetchIsEligibleForAnnualSubscription']),
    ...mapMutations('subscription', ['setStep', 'setType']),
    onBack() {
      Segment.trackUserGot('SubscriptionFlow_BackClicked', { currFlowStep: this.flowStep, moneyBack: this.hasMoneyBackOffer });
      if (this.flowStep === this.SUBSCRIPTION_FLOW_STEPS.subscriptionType) {
        router.push({ path: '/account-settings', query: this.$route.query });
      } else if (this.flowStep === this.SUBSCRIPTION_FLOW_STEPS.creditCard) {
        this.setStep(this.SUBSCRIPTION_FLOW_STEPS.subscriptionType);
      } else {
        this.setStep(this.SUBSCRIPTION_FLOW_STEPS.creditCard);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../scss/mixins';

  .subscription-flow {
  }
</style>
